// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"95fcc04c","76":"31d6cfe0","219":"95fcc04c","630":"95fcc04c","773":"fa945e44","821":"fa945e44","975":"fa945e44"}[chunkId] + ".chunk.css";
};